import React, { useState, useEffect } from "react";
import RequestHandler from "util/RequestHandler";
import config from "../../util/ApiforContext";
import moment from "moment";
import { Tabs, Col, Row, Tooltip,Modal, message,Table,Empty } from "antd";
import { BarsOutlined, RightSquareOutlined, FileExcelOutlined } from "@ant-design/icons";
import { ColumnHelper } from "util/TableHelper";
import BalanceReportTableFilter from "../Filters/BalanceReportTableFilter";
import { odata } from "../Filters/Helper";
const { TabPane } = Tabs;

const ValueReport = (props) => {
  const [activeTabKey, setActiveTabKey] = useState("1");
  const [currencyList, setCurrencyList] = useState([]);
  const [modalVisible, setModalVisible] = useState();
  const [cache, setCache] = useState({});

  const [reportFilters, setReportFilters] = useState({
    daily: {},
    monthly: {},
    operationDateBased: {},
  });

  const getFilterQuery = () => {

    const conditions = [];
    let query = "";

    if (tableDataQueryOptions.bankId) {
      conditions.push(`bankId eq ${tableDataQueryOptions.bankId}`);
    }
    if (tableDataQueryOptions.startDate) {
      conditions.push(odata.dateRange("transactionDate", tableDataQueryOptions.startDate, tableDataQueryOptions.endDate));
    }
    conditions.push(`currencyId eq ${activeTabKey}`)

    if (conditions.length !== 0) {
      query = "$filter=" + conditions.join(" and ");
    }
    return query;
  };

  const onClickExportExcel = () => {
    const hideMessage = message.loading("Excel indiriliyor...", 0);
    RequestHandler.post(
      `/BalanceReport/ExportExcel`,
      {
        query: getFilterQuery(),
      },
      false
    ).then((response) => {
      hideMessage();

      if (response) {
        window.open(
          `${config.apiUrl
          }/BalanceReport/DownloadExcel?fileName=${response}&t=${RequestHandler.getToken()}`
        );
      }
    });
  };

  const columns = [
    {
      title: "Tarih",
      dataIndex: "date",
      render: (data, row, index) => moment(data).format("DD.MM.YYYY"),
    },
    {
      title: "Açılış Bakiyesi",
      dataIndex: "openingBalance",
      align: "right",
      render: (data, row, index) => isDigitReportFromBalance ? ColumnHelper.renderDecimal(data) : ColumnHelper.renderDecimal(data).toString().split(",")[0],
    },
    {
      title: "Kapanış Bakiyesi",
      dataIndex: "closingBalance",
      align: "right",
      render: (data, row, index) => isDigitReportFromBalance ? ColumnHelper.renderDecimal(data) : ColumnHelper.renderDecimal(data).toString().split(",")[0],
    }
  ];
 

  const defaultQueryData = {
    pageSize: 15,
  };

  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [tableDataDetail, setTableDataDetail] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState(defaultQueryData);
  const [tableDataQueryDetailOptions, setTableDataDetailQueryOptions] = useState(defaultQueryData);
  const [isDigitReportFromBalance, setIsDigitReportFromBalance] = useState();

  useEffect(
    () => getTableData(),
    [
      tableDataQueryOptions.bankId,
      tableDataQueryOptions.startDate,
      tableDataQueryOptions.endDate,
    ]
  );

  const getTableData = () => {
    RequestHandler.get(`/TenantUserParameter/GetDigitParameter`).then((response) => {
      if (response.success) {
        setIsDigitReportFromBalance(response.data.isDigitReportFromBalance)
      }
    });
    RequestHandler.get(`/TenantCurrency/GetCurrencyListWithIsCalculated?$filter=CurrencyId ne null&$apply=groupby((Currency,CurrencyId))&$orderby=CurrencyId`)
    .then((response) => {
      setCurrencyList(response);
    });
    setTableData({
      ...tableData,
      loading: true,
    });
         
    RequestHandler.get(
      `/BalanceReport?currencyId=${activeTabKey}`,
      tableDataQueryOptions,
      false
    ).then((response) => {
       setTableData({
         data: response.value,
         total: response.totalCount,
         totalRow: response.totalRow,
         loading: false,
       });
    });

    if (props.onFilterChange) {
      props.onFilterChange(tableDataQueryOptions);
    }
  };

  const detailAccountTransaction = (value) => {
    const columnsDetail = [
      {
        title: "Tarih",
        dataIndex: "transactionDateValue",
        render: (data, row, index) => moment(row.date).format("DD.MM.YYYY HH:mm:ss"),
      },
      {
        title: "Hesap",
        dataIndex: "account",
      },
      {
        title: "İşlem tipi",
        dataIndex: "processType",
      },
      {
        title: "Tutar",
        dataIndex: "amountString",
        render: (data,row,index) => <div style={{whiteSpace: "nowrap"}}>{isDigitReportFromBalance ? row.amountString : row.amountString.split(",")[0]}</div>
      },
      {
        title: "Açıklama",
        dataIndex: "description",
        render: (data, row, index) => row.description
      }
    ];
   
    return (<Table
    columns={columnsDetail}
    locale={{
      emptyText: (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description="Veri Yok"
        />
      ),
    }}
    style={{ overflowX: "auto", maxHeight: "100%" }}
    rowKey={(_, index) => index}
    filterable={true}
    sortable={true}
    pageable={true}
    onChange={pagingDetail}
    pagination={{
      defaultPageSize: 15,
      pageSizeOptions: ["15", "25", "50", "100"],
      total: tableDataDetail.total,
    }}
    dataSource={value}
    size="small"
  />)
  }

  const paging = (p) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        pageSize: p.pageSize,
      };
    });
  };
  const pagingDetail = (p) => {
    setTableDataDetailQueryOptions((prevState) => {
      return {
        ...prevState,
        pageSize: p.pageSize,
      };
    });
  };

  const onClearTableFilter = () => {
    setTableDataQueryOptions(defaultQueryData);
  };
  const openModalSettings = (date,goingOrComing) => {
    setModalVisible(true);
    RequestHandler.get(
      `/AccountTransaction?$count=true&$filter=isErpActivity eq false and transactionDateValue eq ${moment(date).format("YYYY-MM-DD")} &$select=transactionDateValue,tenantAccountName,debtOrCredit,amount,description,iban,tenantAccountNumber`
    ).then((response) => {
      setTableDataDetail({
        data: response.value,
        total: response["@odata.count"],
        loading: false,
      });
    });
  };

  const onChangeCurrncy = (value) => {
    setActiveTabKey(value)
    setTableData({
      ...tableData,
      loading: true,
    });
    RequestHandler.get(
      `/BalanceReport?currencyId=${value}`,
      tableDataQueryOptions,
      false
    ).then((response) => {
       setTableData({
         data: response.value,
         total: response.totalCount,
         totalRow: response.totalRow,
         loading: false,
       });
    });
  };

  const onFinishTableFilter = (query) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        ...query,
      };
    });
  };
  

  const detailTableGroupedByMemberWorkplace = (data) => {
    const columns = [
      {
        title: "Banka",
        dataIndex: "bankLogo",
        width: "8%",
        render: (text) => <img src={text}></img>,
      },
      {
        title: "Gelen Tutar",
        dataIndex: "amountStringComing",
        align:"center",
        render: (data, row, index) => isDigitReportFromBalance ? ColumnHelper.renderDecimal(data) : ColumnHelper.renderDecimal(data).toString().split(",")[0],
      },
      {
        title: "Giden Tutar",
        dataIndex: "amountStringGoing",
        align:"center",
        render: (data, row, index) => isDigitReportFromBalance ? ColumnHelper.renderDecimal(data) : ColumnHelper.renderDecimal(data).toString().split(",")[0],
      }
    ];
  
    return (
      <Table
        columns={columns}
        locale={{
          emptyText: (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Veri Yok" />
          ),
        }}
        expandable={{
          expandedRowRender: (row) =>
            detailAccountTransaction(row.details),
            
        }}
        rowKey={(record) => record.bankId + "-" + record.memberWorkplaceNumber}
        filterable={true}
        sortable={true}
        pagination={false}
        dataSource={data}
        size="small"
      />
    );
  };

  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> BAKİYE RAPORU
          </p>
        </Col>
        <Col xs={24} md={12} lg={8} style={{ textAlign: "right" }}>
         <Tooltip title="Excel İndir">
            <a
              style={{
                color: "green",
                fontSize: "180%",
                marginRight: 30,
              }}
              onClick={onClickExportExcel}
            >
              <FileExcelOutlined />
            </a>
          </Tooltip>
        </Col>
      </Row>
      <BalanceReportTableFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
        monthly={true}
        extraText="Varsayılan olarak bugünden itibaren 15 günlük veri
        listelenmektedir."
      />
      <Tabs
        defaultActiveKey="1"
        onChange={(activeKey) => {
          onChangeCurrncy(activeKey);
        }}
      >
        {
          currencyList.length === 0 ? 
          <div style={{width:'100%'}}> 
           <Table
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }} />
            </div>
          :
       currencyList.map((item, index) => {
            return (
              <TabPane tab={<span>{item.currency}</span>} key={item.currencyId}>
                    <Row id="tableArea">
        <Col span={24}>
          <Table
            columns={columns}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            expandable={{
              expandedRowRender: (row) =>
                detailTableGroupedByMemberWorkplace(row.balanceReportDetailVm),
            }}
            style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
            rowKey={(_, index) => index}
            filterable={true}
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.pageSize,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: tableData.total,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
            size="small"
            summary={() => {
              if (!tableData.totalRow) return;

              const { amount, commissionAmount, netAmount } =
                tableData.totalRow;
              return (
                <Table.Summary.Row>
                  <Table.Summary.Cell></Table.Summary.Cell>
                  <Table.Summary.Cell>Toplam:</Table.Summary.Cell>
                  <Table.Summary.Cell>
                    {ColumnHelper.renderDecimal(amount)}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell colSpan={2}>
                    {ColumnHelper.renderDecimal(commissionAmount)}
                  </Table.Summary.Cell>
                </Table.Summary.Row>
              );
            }}
          />
        </Col>
      </Row>
              </TabPane>
            );
          })
        }
      </Tabs>
      <Modal
        id="accountTransactionDetail"
        centered
        visible={modalVisible}
        onCancel={() => setModalVisible(false) }
        width={950}
        footer={null}
      >
        {/* <Table
            columns={columnsDetail}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{ overflowX: "auto", maxHeight: "100%" }}
            rowKey={(_, index) => index}
            filterable={true}
            sortable={true}
            pageable={true}
            onChange={pagingDetail}
            pagination={{
              defaultPageSize: 15,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: tableDataDetail.total,
            }}
            dataSource={tableDataDetail.data}
            loading={tableDataDetail.loading}
            size="small"
          /> */}
      </Modal>
    </>
  );
};

export default ValueReport;
